<template>
    <main class="main" id="main">
        <div class="top_line">
            <div class="container">
                <h1>Контакты</h1>
            </div>
        </div>

        <!----------Section food cards------------->

        <section class="section s-contacts">
            <div class="container">
                <div class="contact_cards">

                    <div class="card_inner">
                        <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/contacts/1.png" alt="">
                        <h2>ТЕХНИЧЕСКАЯ ПОДДЕРЖКА</h2>
                        <a href="#">webmaster@hochu-poest.com</a>
                        <p>Что-то не работает или работает не так? Такое бывает. Сообщите нам об этом!</p>
                    </div>

                    <div class="card_inner">
                        <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/contacts/2.png" alt="">
                        <h2>ОТДЕЛ МАРКЕТИНГА</h2>
                        <a href="#">pr@hochu-poest.com</a>
                        <p>Мы открыты к любым предложениям и взаимодействию по рекламе. Присылайте нам любые
                            идеи, мысли, предложения и пожелания. Или просто напишите нам о себе, а мы сами
                            придумаем, как можем выгодно посотрудничать.</p>
                    </div>

                    <div class="card_inner">
                        <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/contacts/3.png" alt="">
                        <h2>ЮРИДИЧЕСКИЙ ОТДЕЛ</h2>
                        <a href="#">urist@hochu-poest.com</a>
                        <p>Если у Вас возникли юридические вопросы, пишите сюда:</p>
                    </div>

                    <div class="card_inner resize">
                        <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/contacts/4.png" alt="">
                        <h2>ОТДЕЛ ПЕРСОНАЛА</h2>
                        <a href="#">hr@hochu-poest.com</a>
                        <p>Конечно же, Вы хотите у нас работать! Мы Вас прекрасно понимаем. Присылайте Ваши резюме!</p>
                    </div>

                    <div class="card_inner">
                        <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/contacts/5.png" alt="">
                        <h2>ОТДЕЛ РАБОТЫ С БЛОГГЕРАМИ</h2>
                        <a href="#">blog@hochu-poest.com</a>
                        <p>Все рецепты и статьи для блога присылайте на</p>
                    </div>

                    <div class="card_inner">
                        <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/contacts/6.png" alt="">
                        <h2>ИНВЕСТОРАМ</h2>
                        <a href="#">sev@hochu-poest.com</a>
                        <p>Если мы Вам понравились и вы видите
                            в нас переспективу, инвестируйте в наш сервис и зарабатывайте вместе с нами.</p>
                    </div>

                    <div class="card_inner">
                        <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/contacts/7.png" alt="">
                        <h2>СЛУЖБА ПОДДЕРЖКИ</h2>
                        <a href="#">8 800 100-72-53</a>
                        <p>Нужно решить вопрос быстрее? Напишите нам в чате или позвоните в единую информационную службу:</p>
                    </div>

                    <div class="card_inner">
                        <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/contacts/8.png" alt="">
                        <h2>ОТДЕЛ ПОДКЛЮЧЕНИЯ РЕСТОРАНОВ</h2>
                        <a href="#">ПОДКЛЮЧИТЬ РЕСТОРАН</a>
                        <p>Если Вашего ресторана еще нет на нашем сайте, но Вы готовы присоединиться к нам - жмите!</p>
                    </div>

                </div>
            </div>
        </section>

    </main>

</template>

<script>
export default {
  name: 'contacts'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/articles/contacts.vue